const isLongTermRental = (duration) => Number(duration) >= 6;

const isStudioOrSmallBhk = (bhkType) => {
  const bhk = (bhkType || "").trim();
  return bhk === "Studio" || bhk === "1 BHK" || bhk === "2 BHK";
};

export const getOnboardingCharges = (duration, bhkType) => {
  if (!isLongTermRental(duration)) {
    return 2000;
  }

  if (isStudioOrSmallBhk(bhkType)) {
    return 3000;
  }

  return 5000;
};

export const getRenovationDays = (duration) => {
  const months = Number(duration);

  if (months >= 1 && months <= 5) return 10;
  if (months >= 6 && months <= 11) return 30;

  return 10;
};
